import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";
import { Dialog, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { appIcons } from "../../assets";
import DialogActionButtons from "../dialog/DialogActions";
import DialogBody from "../dialog/DialogBody";
import DialogHeader from "../dialog/DialogHeader";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("24px"),
  },
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));

const DeleteAlert = forwardRef(({ onDelete }, ref) => {
  const [open, setOpen] = useState(false);
  const [dialogData, setDialogData] = useState(null);

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      setDialogData(params);
      setOpen(true);
    },
    closeDialog() {
      setOpen(false);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogHeader
        title={"deleteAddress"}
        secondaryHeading={"undoneAction"}
        icon={<img src={appIcons.deleteIcon} width={30} />}
        onClose={handleClose}
      />

      <DialogBody>
        <Stack alignItems={"center"} justifyContent={"center"}>
          <ReportGmailerrorredIcon
            htmlColor={"red"}
            sx={{
              fontSize: "5rem",
            }}
          />
        </Stack>
        <Typography variant={"body1"} mt={2.5} textAlign={"center"}>
          {dialogData?.warningText}
        </Typography>
      </DialogBody>

      <DialogActionButtons
        confirmText="delete"
        onCancel={handleClose}
        onConfirm={() => onDelete(dialogData)}
      />
    </BootstrapDialog>
  );
});

export default DeleteAlert;
